module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar__top-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), (_vm.stepNumber && !_vm.skipStep) ? _c('span', {
    staticClass: "top-bar__wizard"
  }, [_c('span', {
    staticClass: "m-hidden"
  }, [_vm._v(_vm._s(_vm.wizardText))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.stepNumber))]), _vm._v(" / " + _vm._s(_vm.totalSteps))]) : _vm._e()], 1), _vm._v(" "), _c('header', {
    staticClass: "top-bar__header"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.canGoBack && !_vm.skipStep) ? _c('button', {
    staticClass: "top-bar__back btn-link",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/images/icons/ic_arrow_left.svg",
      "alt": _vm.$t('back')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "underlined"
  }, [_vm._v(_vm._s(_vm.$t('back')))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('h1', {
    key: _vm.header,
    staticClass: "margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.header) + "\n      ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.subHeader) ? _c('h3', {
    key: _vm.subHeader,
    staticClass: "margin-bottom-0 margin-top-0"
  }, [_vm._v("\n        " + _vm._s(_vm.subHeader) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.description) ? _c('p', {
    key: _vm.description,
    staticClass: "margin-top-ms"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd0786dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 549
// module chunks = 2